'use strict';

import { environment } from '@quartz-iam-legacy/environments/environment';

angular.module('userRequestEditControllers')

.controller('MainController', ['$scope', '$state', '$stateParams', '$translate', 'searchService', 'userRequest', 'authenticatedUser', 'systemTypes', 'sameAsEmployee', 'topBar', function ($scope, $state, $stateParams, $translate, searchService, userRequest, authenticatedUser, systemTypes, sameAsEmployee, topBar) {
    $scope.userRequest = userRequest;
    $scope.authenticatedUser = authenticatedUser;
    $scope.systemTypes = systemTypes;
    $scope.idUrl = environment.idUrl;

    $translate('iam.userRequest.userRequestEdit.pageTitle', {requestId: userRequest.UserAccessRequestID}).then(function(translation) {
        topBar.setTitleAndIcon(translation, 'fa-inbox');
    });

    // UnderReview and Admin ?
    if ($state.is('userAccessRequest.edit') &&
        userRequest.IsUnderReview && authenticatedUser.IsInAdministrationGroup) {

        $state.go('userAccessRequest.edit.validationMessages', {
            userAccessRequestId: userRequest.UserAccessRequestID
        });
    }

    // Get first system type
    $scope.firstSystemType = _.chain(systemTypes)
                              .sortBy('Name')
                              .first()
                              .value();

    // Same AS
    if (!_.isUndefined(sameAsEmployee)) {
        $scope.sameAsEmployee = sameAsEmployee.data;
    }

    // Search by business tasks
    $scope.ctxSearchBusinessTask = {};
    $scope.ctxSearchBusinessTask.businessTasks = [];
    $scope.ctxSearchBusinessTask.searchTerm = $stateParams.search;

    $scope.ctxSearchBusinessTask.search = function () {
        var searchTerm = $scope.ctxSearchBusinessTask.searchTerm;

        if (_.isUndefined(searchTerm) || searchTerm.length === 0) { //|| !$state.includes('userAccessRequest.edit.taskcatalog')) {
            $scope.ctxSearchBusinessTask.businessTasks = [];
            return;
        }

        searchService.searchBusinessTasks(searchTerm)
        .then(function (foundTasks) {
            $scope.ctxSearchBusinessTask.businessTasks = foundTasks;
        });
    }
    $scope.ctxSearchBusinessTask.search();

    $scope.ctxSearchBusinessTask.withSearch = function () {
        return !_.isUndefined($scope.ctxSearchBusinessTask.searchTerm) &&
               $scope.ctxSearchBusinessTask.searchTerm.length > 0;
    }

    $scope.ctxSearchBusinessTask.tasksByActivity = function (businessActivity) {
        return _.filter($scope.ctxSearchBusinessTask.businessTasks,
                        { 'BusinessActivityId': businessActivity.BusinessActivityId });
    }

    // Search by systems
    $scope.ctxSearchSystem = {};
    $scope.ctxSearchSystem.systems = [];
    $scope.ctxSearchSystem.systemsByType = [];
    $scope.ctxSearchSystem.searchTerm = $stateParams.search;

    $scope.ctxSearchSystem.search = function () {
        var searchTerm = $scope.ctxSearchSystem.searchTerm;

        if (_.isUndefined(searchTerm) || searchTerm.length === 0 || $state.includes('userAccessRequest.edit.taskcatalog')) {
            $scope.ctxSearchSystem.systems = [];
            $scope.ctxSearchSystem.systemsByType = [];
            $scope.ctxSearchSystem.systemTypeIDs = [];
            return;
        }

        searchService.basicSearchSystems(searchTerm)
        .then(function (foundSystems) {
            $scope.ctxSearchSystem.systems = foundSystems;
            $scope.ctxSearchSystem.systemsByType = _.groupBy(foundSystems, 'SystemTypeID');
            $scope.ctxSearchSystem.systemTypeIDs = _.map(Object.keys($scope.ctxSearchSystem.systemsByType), 
                                                         function(idnum) { return parseInt(idnum); });
        });
    }
    $scope.ctxSearchSystem.search();

    $scope.ctxSearchSystem.withSearch = function () {
        return !_.isUndefined($scope.ctxSearchSystem.searchTerm) &&
               $scope.ctxSearchSystem.searchTerm.length > 0;
    }

    $scope.ctxSearchSystem.toDisplaySystemType = function (systemType) {
        if ($scope.ctxSearchSystem.withSearch()) {
            return !_.isUndefined($scope.ctxSearchSystem.systemsByType[systemType.SystemTypeID])
        }
        else {
            return true;
        }
    }

    $scope.ctxSearchSystem.systemsBySystemType = function (systemType) {
        return $scope.ctxSearchSystem.systemsByType[systemType.SystemTypeID];
    }

    // Go To Process
    $scope.goToProcess = function () {
        window.location = environment.idUrl +
            '/access-requests(modal:access-request-details)?userAccessRequestId=' +
            $scope.userRequest.UserAccessRequestID;
    }

    // Go To SystemType
    $scope.goToEditSystemType = function (systemType, params) {

        var sameAsEmployeeId;
        if (!_.isUndefined($scope.sameAsEmployee)) {
            sameAsEmployeeId = $scope.sameAsEmployee.EmployeeID;
        }
        if (!_.isUndefined(params.sameAsEmployee)) {
            sameAsEmployeeId = params.sameAsEmployee.EmployeeID;
        }

        // Network Share ?
        if (systemType.SystemTypeID === 4) {
            $state.go('userAccessRequest.edit.networkShare', {
                userAccessRequestId: $scope.userRequest.UserAccessRequestID,
                search: $scope.ctxSearchSystem.searchTerm,
                sameAsEmployeeId: sameAsEmployeeId
            }, { reload: true });
        }
        else {
            $state.go('userAccessRequest.edit.systemtype', {
                userAccessRequestId: $scope.userRequest.UserAccessRequestID,
                slugSystemType: systemType.Slug,
                search: $scope.ctxSearchSystem.searchTerm,
                sameAsEmployeeId: sameAsEmployeeId
            }, { reload: true });
        }
    }

    $scope.isEditSystemType = function (systemType) {

        // Network Share ?
        if (systemType.SystemTypeID === 4) {
            return $state.includes('userAccessRequest.edit.networkShare');
        }
        else {
            return $state.includes('userAccessRequest.edit.systemtype') &&
                   $state.params.slugSystemType === systemType.Slug;
        }
    }

    // Go To BusinessTask
    $scope.goToEditBusinessTask = function (businessTask) {

        var sameAsEmployeeId;
        if (!_.isUndefined($scope.sameAsEmployee)) {
            sameAsEmployeeId = $scope.sameAsEmployee.EmployeeID;
        }

        $state.go('userAccessRequest.edit.taskcatalog.businessactivity.businesstask', {
            userAccessRequestId: $scope.userRequest.UserAccessRequestID,
            businessActivityId: businessTask.BusinessActivityId,
            businessTaskId: businessTask.BusinessTaskID,
            search: $scope.ctxSearchBusinessTask.searchTerm,
            sameAsEmployeeId: sameAsEmployeeId
        }, { reload: true });
    }
}]);